module.exports = __webpack_public_path__ + "media/img/logo_icon-7486f775.png";